const CONDUCT_ALL_IN_SCOPE_URL =
  '/_api/wix-laboratory-server/v1/laboratory/platform/conductAllInScope';

interface ConductExperimentParams {
  key: string;
  scope: string;
  cidx?: string;
}

export const conductExperiment = async ({
  key,
  scope,
  cidx,
}: ConductExperimentParams): Promise<boolean> => {
  let url = `${CONDUCT_ALL_IN_SCOPE_URL}?scope=${encodeURIComponent(scope)}`;
  if (cidx) {
    url += `&requestContext.forCidx.cidx=${encodeURIComponent(cidx)}`;
  }
  const response = await fetch(url);
  const data = await response.json();
  return data?.values?.[key] === 'true';
};
